// extracted by mini-css-extract-plugin
module.exports = {"bg":"country_redirect_header_bg__9HfLO","banner-text":"country_redirect_header_banner-text__uJHd6"};